import { createContext } from 'react';

export interface WrapperContextProps {
  searchInput: string;
  setSearchInput: (input: string) => void;
}

const WrapperContext = createContext<WrapperContextProps>({
  searchInput: '',
  setSearchInput: () => {},
});

export default WrapperContext;
